exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".wrapper-name[data-v-c5d9fa2e]{display:flex;white-space:nowrap}.wrapper-name .name[data-v-c5d9fa2e]{overflow:hidden;white-space:nowrap;text-overflow:ellipsis}", ""]);

// exports
